import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  const breadcrumbs = [
    { label: 'Página Inicial', href: '/' },
    ...pathnames.map((value, index) => {
      const href = `/${pathnames.slice(0, index + 1).join('/')}`;
      return { label: value.charAt(0).toUpperCase() + value.slice(1), href };
    })
  ];

  return (
    <nav style={{ "--bs-breadcrumb-divider": `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E")` }} aria-label="breadcrumb">
      <ol className="breadcrumb">
        {breadcrumbs.map((item, index) => (
          <li key={index} className={`breadcrumb-item ${index === breadcrumbs.length - 1 ? 'active' : ''}`} aria-current={index === breadcrumbs.length - 1 ? 'page' : undefined}>
            {index === breadcrumbs.length - 1 ? item.label : <Link to={item.href}>{item.label}</Link>}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;